<template>
    <v-card>

        <v-card-title v-text="`${$props.snmpItemClone.unique_key ? 'Edit' : 'New'} SNMP Item`"></v-card-title>

        <v-divider />

        <v-card-text>
            <v-form ref="snmpForm" :lazy-validation="true" v-model="formValid">
                <v-row dense>
                    <v-col cols="8">
                        <v-text-field v-model="$props.snmpItemClone.key" color="#c42111" label="Host" :rules="[validation.required($props.snmpItemClone.key, 'Key'), validation.ipAddrOrSubnet($props.snmpItemClone.key)]" />
                    </v-col>
                    <v-col cols="4">
                        <v-select v-model="$props.snmpItemClone.version" :items="versionOptions" color="#c42111" label="Version" :rules="[validation.required($props.snmpItemClone.version, 'Version')]" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="$props.snmpItemClone.community" color="#c42111" label="Community String" :rules="[validation.required($props.snmpItemClone.community, 'Community')]" />
                    </v-col>
                    <v-col cols="12">Frequeny</v-col>
                    <v-col cols="4">
                        <v-autocomplete autocomplete="off" v-model="hoursValue" :items="hoursOptions" color="#c42111" label="Hours" :rules="[validation.min5Min(frequencySeconds), validation.max24Hours(frequencySeconds)]" />
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete autocomplete="off" v-model="minValue" :items="minsOptions" color="#c42111" label="Minutes" :rules="[validation.min5Min(frequencySeconds), validation.max24Hours(frequencySeconds)]" />
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete autocomplete="off" v-model="secValue" :items="secOptions" color="#c42111" label="Seconds" :rules="[validation.min5Min(frequencySeconds), validation.max24Hours(frequencySeconds)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete autocomplete="off" v-model="$props.snmpItemClone.pm_groups" multiple :items="$props.pmGroupItems" chips color="#c42111" label="PM Groups" :rules="[validation.requiredItem($props.snmpItemClone.pm_groups, 'PM Groups')]" />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn @click="$emit('cancel')" text>Cancel</v-btn>
            <v-btn @click="okClicked" text>Ok</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
export default {
    name: 'SnmpEdit',
    props: ['pmGroupItems', 'snmpItemClone'],
    components: {

    },
    data: () => ({
        formValid: true,
        versionOptions: ['1', '2c'],
        hoursOptions: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
        minsOptions: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59],
        secOptions: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59],
        hoursValue: 0,
        minValue: 0,
        secValue: 0,
        //pmGroupItems: ['ifmib', 'cisco_process', 'cisco_memory'],
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            //ipAddr: (value) => ((/^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/.test(value)) || 'Invalid IP Address'),
            //ipSubnet: (value) => ((/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/\d+$/.test(value)) || 'Invalid IP Address'),
            ipAddrOrSubnet: (value) => ((/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/\d+$/.test(value)) || (/^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/.test(value)) || 'Invalid IP Address/Subnet'),
            min5Min: (value) => (value >= 300 || 'Minimum Frequency is 5 minutes'),
            max24Hours: (value) => (value <= 86400 || 'Maximum Frequency is 24 hours'),
            requiredItem: (value, fieldName) => (value.length > 0 || `A value is required`)
        },
    }),

    computed: {
        frequencySeconds: function() {
            return ((parseInt(this.hoursValue) * 3600) + (parseInt(this.minValue) * 60) + parseInt(this.secValue));
        }
    },

    methods: {
        okClicked: function() {
            if(this.$refs.snmpForm.validate()) {
                this.$props.snmpItemClone.frequency = this.frequencySeconds;
                this.$emit('ok');
            }
        }
    },

    created() {
        let freqSec = this.$props.snmpItemClone.frequency;
        if(freqSec == 86400) {
            this.hoursValue = 24;    
            this.minValue = 0;
            this.secValue = 0;
            return;
        }
        let hms = new Date(freqSec * 1000).toISOString().substr(11, 8)
        this.hoursValue = parseInt(hms.split(':')[0]);
        this.minValue = parseInt(hms.split(':')[1]);
        this.secValue = parseInt(hms.split(':')[2]);
    }

  
};
</script>
